import { DatasetStatus, PendingStatus } from '@components'
import { colors } from '@global/constants'

/**
 * There are a few cases where the status chip label will be different than the actual status.
 * We don't show Complete, Approved, or Pending as statuses in the UI.
 *
 * @param {DatasetStatus | PendingStatus} status The status of the submission
 * @returns
 */
export function getStatusLabel(status: DatasetStatus | PendingStatus) {
  switch (status) {
    case DatasetStatus.COMPLETE: {
      return 'Success'
    }
    case DatasetStatus.APPROVED:
    case DatasetStatus.PENDING: {
      return 'Processing'
    }
    default: {
      return status
    }
  }
}

export function getStatusColors(status: DatasetStatus | PendingStatus) {
  let backgroundColor: string = colors.green.main
  let color: string = colors.white

  switch (status) {
    case PendingStatus.AWAITING_APPROVAL:
      backgroundColor = colors.gray.main
      color = colors.black
      break
    case PendingStatus.DRAFT:
      break
    case PendingStatus.ERROR:
    case PendingStatus.FAILED_VALIDATION:
      backgroundColor = colors.red.main
      break
    case PendingStatus.PAUSED:
      backgroundColor = colors.purple.main
      break
    case PendingStatus.SHARED_DRAFT:
      backgroundColor = colors.purple.dark
      break
    case DatasetStatus.PENDING:
    case DatasetStatus.APPROVED:
      backgroundColor = colors.blue.main
      break
    case DatasetStatus.WARNING:
      backgroundColor = colors.yellow.main
      break
    default:
      break
  }

  return {
    backgroundColor,
    color,
  }
}
